import { deepCopy, getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { DeliveryOrderService } from './../../services/delivery-order.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { OptionsMappingPipe } from 'src/app/shared/pipes/options-mapping.pipe';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { BookingService } from './../../services/booking.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

@Component({
  selector: 'laas-do-search-import',
  templateUrl: './do-search-import.component.html',
  styleUrls: ['./do-search-import.component.scss']
})
export class DoSearchImportComponent extends SessionBaseComponent implements OnInit {

  @ViewChild(Table) tableComponent!: Table;
  @Input() checkedDOs: any[];
  @Output() DOImported: EventEmitter<any>;
  readonly preferenceKey: string;
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewDoSearchImport;
  readonly defaultSearchParams: any;
  @ViewChild('etd') etd!: CalendarComponent;
  @ViewChild('invoiceDt') invoiceDt!: CalendarComponent;
  searchForm: FormGroup;
  isSearchFormOpen: boolean;
  isLoading: boolean;
  columns: any[];
  selectedCols: any[];
  DORows: any[];
  selectedDORows: any[];
  searchParams: any;
  DOStatusOptions: any[];
  DOBookingStatusOptions: any[];
  letterHeadOptions: any[];
  orgIdsOptions: any[];
  shipCorpsOptions: any[];
  orgOptions: any[]
  incotermOptions: any[];
  incoTermList: LaasOption[];
  deliveryTypeOptions: any[];
  pageInfo: PageInfo;
  sortInfo: { property: string, direction: number } | null;
  waitingReasonOptions: any[];
  noShippingReasonOptions: any[];
  facilityOptions: any[];
  isShowControlledItemModal: boolean;
  isControlledItemList: any;
  selectedCartonsInfo: {
    cartonCnt: string,
    totalNetWeight: string,
    totalGrossWeight: string,
    volumeWeight: string,
    cbm:string,
    pieces:string,
    price:string,
    currencyCode:string
  };
  selectedPickingType: any;
  selectedPickingText: any;
  isActive: any;
  @Input() isNeedShowPicking: boolean;
  isSameCurrencyCode: boolean;

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private bookingService: BookingService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private optionsMappingPipe: OptionsMappingPipe,
    private fb: FormBuilder) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.DOSearchImport;
    this.defaultSearchParams = {
      doNos: [],
      tenants: [],
      letterHeadOrgIds: [],
      orgIds: [],
      shipCorps: [],
      consigneeKey: null,
      consigneeCompany: null,
      incoTerm: null,
      etdStart: null,
      etdEnd: null,
      deliveryType: null,
      dischargeType: null,
      invoiceDateStart: null,
      invoiceDateEnd: null,
      bookingCount: null,
      salesCode: null,
      status: null,
      doBookingStatus: null,
      selectedFacility: [],
      invoiceNos:[]
    };
    this.checkedDOs = [];
    this.DOImported = new EventEmitter<any>();
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.columns = [
      { field: 'doNo', header: 'DOQuery.Form.Column.DONum', sort: true },
      { field: 'letterHeadOrgId', header: 'DOQuery.Form.Column.LetterHeadComp', sort: true },
      { field: 'shipCorp', header: 'DOQuery.Form.Column.ShipOutComp', sort: true },
      { field: 'orgId', header: 'DOQuery.Form.Column.LoadOrderComp', sort: true },
      { field: 'consigneeKey', header: 'DOQuery.Form.Column.CustomerCode', sort: true },
      { field: 'consigneeCompany', header: 'DOQuery.Form.Column.CustomerName', sort: true },
      { field: 'incoTerm', header: 'DOQuery.Form.Column.TradeTerm', sort: true },
      { field: 'etd', header: 'DOQuery.Form.Column.ETD', dataType: 'date', sort: true },
      { field: 'eta', header: 'DOQuery.Form.Column.ETA', dataType: 'date', sort: true },
      { field: 'deliveryType', header: 'DOQuery.Form.Column.DeliveryLocate', sort: true },
      { field: 'dischargeType', header: 'DOQuery.Form.Column.DeliveryMode', sort: true },
      { field: 'shipToAddress', header: 'DOQuery.Form.Column.ShipAddr', sort: true },
      { field: 'deliveryToAddress', header: 'DOQuery.Form.Column.DeliverAddr', sort: true },
      { field: 'shipNotes', header: 'DOQuery.Form.Column.ShippingInstruct', sort: false },
      { field: 'cartonCnt', header: 'DOQuery.Form.Column.TotalCartonCnt', sort: true },
      { field: 'totalNetWeight', header: 'DOQuery.Form.Column.NetWeight', sort: true },
      { field: 'totalGrossWeight', header: 'DOQuery.Form.Column.GrossWeight', sort: true },
      { field: 'volumeWeight', header: 'DOQuery.Form.Column.VolumeWeight', sort: true },
      { field: 'cbm', header: 'DOQuery.Form.Column.Cbm', sort: false },
      { field: 'pieces', header: 'DOQuery.Form.Column.Pieces', sort: false },
      { field: 'price', header: 'DOQuery.Form.Column.Price', sort: false },
      { field: 'paymentTerm', header: 'DOQuery.Form.Column.PaymentTerm', sort: true },
      { field: 'storer', header: 'DOQuery.Form.Column.Storer', sort: true },
      { field: 'tenant', header: 'DOQuery.Form.Column.Group', sort: true },
      { field: 'invoiceDate', header: 'DOQuery.Form.Column.InvoiceDT', dataType: 'date', sort: true },
      { field: 'reasons', header: 'DOQuery.Form.Column.OnHoldReason', dataType: 'array', sort: false },
      { field: 'csr', header: 'DOQuery.Form.Column.CSR', sort: true },
      { field: 'salesCode', header: 'DOQuery.Form.Column.Sales', sort: true },
      { field: 'dept', header: 'DOQuery.Form.Column.Department', sort: true },
      {
        field: 'doStatus',
        header: 'DOQuery.Form.Column.DOStatus',
        sort: true,
        transform: (value: any) => this.optionsMappingPipe.transform(value, this.DOStatusOptions)
      },
      {
        field: 'doBookingStatus',
        header: 'DOQuery.Form.Column.DOBookStatus',
        sort: true,
        transform: (value: any) => this.optionsMappingPipe.transform(value, this.DOBookingStatusOptions)
      },
      { field: 'isDropRemark', header: 'DOQuery.Form.Column.DropShipFlag', sort: true },
      { field: 'bookingNo', header: 'DOQuery.Form.Column.BookingNum', sort: false },
      { field: 'facility', header: 'DOQuery.Form.Column.Facility', sort: true },
      { field: 'bookingCount', header: 'DOQuery.Form.Column.BOLCnt', sort: true },
      { field: 'license', header: 'DOQuery.Form.Column.License', sort: false },
      { field: 'sku', header: 'DOQuery.Form.Column.SKU', sort: false },
      { field: 'brand', header: 'DOQuery.Form.Column.Brand', sort: false }
    ];
    const dataTablePreference = this.getDataTablePreference(this.preferenceKey)
    this.selectedCols = this.columns;
    this.sortInfo = isNullOrEmpty(dataTablePreference?.state?.sortField) || isNullOrEmpty(dataTablePreference?.state?.sortOrder) ? null :
      { property: dataTablePreference?.state?.sortField, direction: dataTablePreference?.state?.sortOrder };
    this.DORows = [];
    this.selectedDORows = [];
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.DOStatusOptions = [];
    this.DOBookingStatusOptions = [];
    this.searchForm = this.fb.group({
      doNos: [],
      tenants: [],
      letterHeadOrgId: [],
      orgIds: [],
      shipCorps: [],
      consigneeKey: null,
      consigneeCompany: null,
      incoTerm: null,
      etdStart: null,
      etdEnd: null,
      deliveryType: null,
      dischargeType: null,
      invoiceDateStart: null,
      invoiceDateEnd: null,
      bookingCount: null,
      salesCode: null,
      status: [],
      facility: null,
      doBookingStatus: null,
      invoiceNos:[]
    });

    this.letterHeadOptions = [];
    this.orgIdsOptions = [];
    this.shipCorpsOptions = [];
    this.orgOptions = [];
    this.incotermOptions = [];
    this.incoTermList = [];
    this.deliveryTypeOptions = [];
    this.waitingReasonOptions = [];
    this.noShippingReasonOptions = [];
    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };
    this.facilityOptions = [];
    this.isShowControlledItemModal = false;
    this.isControlledItemList = [];
    this.selectedCartonsInfo = {
      cartonCnt: "",
      totalNetWeight: "",
      totalGrossWeight: "",
      volumeWeight: "",
      cbm: "",
      pieces: "",
      price: "",
      currencyCode: ""
    };
    this.selectedPickingText = this.translateService.instant('BookingPreview.DOList.Picking');
    this.isActive = "0";
    this.isNeedShowPicking = false;
    this.selectedPickingType = "0";
    this.isSameCurrencyCode = true;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.searchParams.facility = this.laasSetting.facility;
    this.dropdownOptionsService.getLetterOrgOptions()
      .subscribe({
        next: (options: any[]) => {
          this.letterHeadOptions = this.orgIdsOptions = this.shipCorpsOptions = options;
          this.orgOptions = options.map(x => ({ label: x.legalEntityOUName, value: x.legalEntityOUCode }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.incotermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });
    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.incoTermList = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionsService.getDeliveryTypeOptions(false)
      .subscribe({
        next: (options: any[]) => {
          this.deliveryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionsService.getDOStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionsService.getDOBookingStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOBookingStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'NoShippingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.noShippingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'WaitingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.waitingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });
    this.dropdownOptionsService.getFacilityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
  }

  /**
   * Search form search button click event.
   * @param event Button click event.
   */
  searchBtnClick(event: any): void {
    if (isNullOrEmpty(this.searchParams.status)) {
      this.searchParams.statuses = [];
    } else {
      this.searchParams.statuses = [this.searchParams.status];
    }

    this.pageInfo.pageIndex = 0;
    this.loadDeliveryOrdersForShipping(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  selectedPicking($event:any){
    if (this.selectedPickingType == "0") {
      this.selectedPickingText = this.translateService.instant('BookingPreview.DOList.NoPicking');
      this.selectedPickingType = "1";
    } else {
      this.selectedPickingText = this.translateService.instant('BookingPreview.DOList.Picking');
      this.selectedPickingType = "0";
    }
  }

  importBtnClick(event: any): void {
    const deletedDOs = this.DORows
    .filter(x => this.checkedDOs.map(y => y.doNo).indexOf(x.doNo) > -1)
    .filter(x => this.selectedDORows.map(y => y.doNo).indexOf(x.doNo) === -1);
    this.DOImported.emit({ originalEvent: event, data: { deleted: deletedDOs, selected: this.selectedDORows }, isActive: this.selectedPickingType });
  }

  /**
   * Search form reset button click event.
   * @param event Button click event.
   */
  resetBtnClick(event: any): void {
    this.etd.ngOnInit();
    this.invoiceDt.ngOnInit();
    this.searchForm.reset();
    this.searchParams.invoiceDateStart = null;
    this.searchParams.invoiceDateEnd = null;
    this.searchParams.etdStart = null;
    this.searchParams.etdEnd = null;
  }

  /**
   * Datatable paging event.
   * @param event p-table onPage event.
   */
  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.loadDeliveryOrdersForShipping(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  tableSort(event: any): void {
    this.sortInfo = { property: event.field, direction: event.order };
    this.loadDeliveryOrdersForShipping(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  /**
   * DO number field add event.
   * @param event p-chips onAdd event.
   */
  doNoChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.doNos.splice(this.searchParams.doNos.indexOf(value));
    this.searchParams.doNos = this.searchParams.doNos.concat(parsedValues);
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split(',').filter(x => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  private loadDeliveryOrdersForShipping(pageIndex: number, pageSize: number, sort?: any): void {
    this.selectedDORows.length=0;
    this.resetCartonsInfo();

    const params = deepCopy(this.searchParams);
    params.facility = this.laasSetting.facility;
    params.pageIndex = pageIndex;
    params.pageSize = pageSize;
    params.sortOrders = isNullOrEmpty(sort) ? null : [sort];
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.statuses = isNullOrEmpty(params.status) ? [] : [params.status];
    params.etdStart = isNullOrEmpty(params.etdStart) ? null : new Date(params.etdStart).toISOString();
    params.etdEnd = isNullOrEmpty(params.etdEnd) ? null : new Date(params.etdEnd).toISOString();
    params.invoiceDateStart = isNullOrEmpty(params.invoiceDateStart) ? null : new Date(params.invoiceDateStart).toISOString();
    params.invoiceDateEnd = isNullOrEmpty(params.invoiceDateEnd) ? null : new Date(params.invoiceDateEnd).toISOString();

    this.isLoading = true;
    this.DOService.getDeliveryOrdersForShipping(params)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: result => {
          this.isSearchFormOpen = false;
          this.DORows = result.content.map((x: any) => {
            x.reasons = this.getFormatedReasons(x);
            return x;
          });
          this.pageInfo.totalRecords = result.totalElements;
          this.pageInfo.totalPages = result.totalPages;
          this.checkedDOs.forEach(x => {
            const targetIdx = this.DORows.findIndex(y => y.doNo === x.doNo);
            if (targetIdx > -1) {
              const idx = this.selectedDORows.findIndex(y => y.doNo === x.doNo);
              if (idx < 0) {
                this.selectedDORows.push(this.DORows[targetIdx]);
              }
            }
          });
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error);
        }
      });
  }

  private getFormatedReasons(rowData: any): string[] {
    let waitingReasons = (isNullOrEmpty(rowData.waitingReason) ? [] : rowData.waitingReason.split(','))
      .map((x: string) => {
        return this.optionsMappingPipe.transform(x, this.waitingReasonOptions);
      });

    const noShippingReason = this.optionsMappingPipe.transform(rowData.noShippingReason, this.noShippingReasonOptions);
    if (!isNullOrEmpty(noShippingReason)) {
      waitingReasons = waitingReasons.concat(noShippingReason);
    }

    return waitingReasons;
  }

  selectedRowsChange(event: any): void {
    if (this.selectedDORows.length > 0) {
      const reducer = (accumulator: any, currentValue: any) => accumulator + currentValue;
      this.selectedCartonsInfo.cartonCnt = this.calculateTotalProperty(this.selectedDORows, 'cartonCnt',reducer,false);
      this.selectedCartonsInfo.totalGrossWeight = this.calculateTotalProperty(this.selectedDORows, 'totalGrossWeight',reducer,false);
      this.selectedCartonsInfo.totalNetWeight = this.calculateTotalProperty(this.selectedDORows, 'totalNetWeight',reducer,false);
      this.selectedCartonsInfo.volumeWeight = this.calculateTotalProperty(this.selectedDORows, 'volumeWeight',reducer,false);
      this.selectedCartonsInfo.cbm = this.calculateTotalProperty(this.selectedDORows, 'cbm',reducer,true);
      this.selectedCartonsInfo.pieces = this.calculateTotalProperty(this.selectedDORows, 'pieces',reducer,false);
      this.selectedCartonsInfo.price = this.calculateTotalProperty(this.selectedDORows, 'price',reducer,false);
      this.isCurrencyCode();
    }
    else{
      this.resetCartonsInfo();
    }
  }

  //因為下面使用string來進行千分位格式轉換  所以回傳也要是string否則會顯示NaN
  calculateTotalProperty(rows: any[], property: string, reducer: any,isCeil:boolean): string {
    const sum = rows
      .filter(x => x[property] != null)
      .map(x => x[property])
      .reduce(reducer, 0);
      var formattedSum;
      if(Number.isInteger(sum)){
        formattedSum = sum.toString();
      }else if(isCeil){
        formattedSum = this.roundUp(sum,2);
      }else {
        formattedSum = sum.toFixed(2);
      }
      return this.formatNumber(formattedSum);
  }

  formatNumber(num: string) {
    var parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  roundUp( num:number, decimal:number ) {
    return Math.ceil( ( num + Number.EPSILON ) * Math.pow( 10, decimal ) ) / Math.pow( 10, decimal ); }

  isCurrencyCode() {
    let referenceCurrencyCode: string | null = null;
    //有些DO沒有發票 要找第一個不是Null的當參考值
    for (let i = 0; i < this.selectedDORows.length; i++) {
      if (this.selectedDORows[i].currencyCode !== null) {
        referenceCurrencyCode = this.selectedDORows[i].currencyCode;
        break;
      }
    }

    // 如果所有都是 null=>true
    if (referenceCurrencyCode === null) {
      this.isSameCurrencyCode = true;
      return;
    }

    const filteredRows = this.selectedDORows.filter(row => row.currencyCode !== null);

    if (filteredRows.every(row => row.currencyCode === referenceCurrencyCode)) {
      this.isSameCurrencyCode = true;
      this.selectedCartonsInfo.currencyCode = referenceCurrencyCode;
    } else {
      this.isSameCurrencyCode = false;
    }
  }

  resetCartonsInfo():void{
    this.selectedCartonsInfo = {
      cartonCnt: "",
      totalNetWeight: "",
      totalGrossWeight: "",
      volumeWeight: "",
      cbm: "",
      pieces: "",
      price: "",
      currencyCode: ""
    };
  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "etd" :
        this.searchParams.etdStart = date.startDate;
        this.searchParams.etdEnd = date.endDate;
        break;
      case "invoiceDt":
        if (!isNullOrEmpty(date.startDate)) {
          this.searchParams.invoiceDateStart = date.startDate.setSeconds(0);
        } else {
          this.searchParams.invoiceDateStart = date.startDate;
        }

        if (!isNullOrEmpty(date.endDate)) {
          this.searchParams.invoiceDateEnd = date.endDate.setSeconds(0);
        } else {
          this.searchParams.invoiceDateEnd = date.endDate;
        }

        break;
    }
  }

  setPageSize(event: any): void {
    this.pageInfo.pageSize = event.rows;
  }
}
